import OutsourcingTable from '@components/common/Table/OutsourcingTable';
import React from 'react';

const Outsourcing = ({ 
  getSeachExcel, 
  getPaymentExcel, 
  getMonthlyFinanceList, 
  monthlyFinanceList, 
  monthlyFinanceListTotal,
  monthlyFinanceListTotalAmount,
  projectName, 
  companyName, 
  setProjectName, 
  setCompanyName,
  page,
  setPage,
  limit,
  setLimit,
  orderBy,
  setOrderBy,
  orderDir,
  setOrderDir
}) => {
  return <OutsourcingTable 
    getSeachExcel={getSeachExcel} 
    getPaymentExcel={getPaymentExcel} 
    getMonthlyFinanceList={getMonthlyFinanceList} 
    monthlyFinanceList={monthlyFinanceList} 
    monthlyFinanceListTotal={monthlyFinanceListTotal}
    monthlyFinanceListTotalAmount={monthlyFinanceListTotalAmount}
    projectName={projectName} 
    companyName={companyName} 
    setProjectName={setProjectName} 
    setCompanyName={setCompanyName} 
    page={page} 
    setPage={setPage} 
    limit={limit} 
    setLimit={setLimit} 
    orderBy={orderBy}
    setOrderBy={setOrderBy}
    orderDir={orderDir}
    setOrderDir={setOrderDir}
  />;
};

export default Outsourcing;
